<template>
  <vx-tooltip :text="!valueBoolean ? 'Publicar top' : 'No publicar top'">
    <vs-switch
        v-model="valueBoolean"
        @change="markAsPopular()"></vs-switch>
  </vx-tooltip>
</template>

<script>
import swal from "sweetalert";
import {AxiosErrorException} from "../views/admin/functions/axiosErrorException";

export default {
  name: "ButtonMarkProjectAsRecommended",
  data: () => ({
    requestInProcessing: false
  }),
  props: {
    value: {
      type: Number,
      default: 0,
      required: true
    },
    project_id: {
      type: Number,
      required: true
    }
  },
  computed: {
    valueBoolean() {
      return (this.value === 1);
    }
  },
  methods: {
    async markAsPopular() {
      try {

        let value = (this.valueBoolean) ? 0 : 1;

        this.$emit('input', this.value);

        this.requestInProcessing = true;

        await axios.put(`/api/project/${this.project_id}`, {
          public_top: value
        });

        this.value = value;
        this.requestInProcessing = false;

        if (this.value) {
          swal("Ok!", "El proyecto se marco como recomendado")
        } else {
          swal("Ok!", "El proyecto se desmarco como recomendado")
        }
      } catch (e) {
        console.error(e)
        swal('Ups!', AxiosErrorException(e), 'error')
      }
    }
  }
}
</script>

<style scoped>

</style>
